export default "/79443f7e87b8c39b0147b6b66948e511.jpg";